import { injectGlobal } from 'emotion'
import { font, color } from './theme'

// Set box-sizing globally to handle padding and border widths
const all = `
  *,
  *:after,
  *:before {
      box-sizing: inherit;
  }
  
  * {
    background-repeat: no-repeat;
  }
`

const html = `
  html {
    box-sizing: border-box;
    font-size: 62.5%;
    cursor: default;
    -webkit-font-smoothing: antialiased;
    overflow-x: hidden;
  }
`

const body = `
    body {
        margin: 0;
        font-family: ${font.family};
        font-size: ${font.size};
        line-height: ${font.lineHeight};
        letter-spacing: ${font.letterSpacing};
        color: ${font.color};
        overflow-x: hidden;
    }
`

const links = `
  a {
    text-decoration: none;
    color: inherit;
  }
`

const typography = `
  h1, h2, h3, h4, h5, h6 {
    margin: 0 0 8px;
  }

  p {
    margin: 0 0 1em;
    &:last-child {
      margin-bottom: 0;
    }
  }
`

const forms = `
  input {
    padding: 1rem;
    border:none;
    outline: none;
    font-family: ${font.family};
    font-size: ${font.size};

    &::placeholder {
      color: ${color['gray2']};
    }
  }
`

const buttons = `
  button {
    font-family: ${font.family};
    background: none;
    border: none;
    padding: 0;
    outline: none;
    cursor: pointer;
  }
`

export default () => injectGlobal`
    ${all};
    ${html};
    ${body};
    ${links};
    ${typography};
    ${forms};
    ${buttons};
`



// WEBPACK FOOTER //
// ./src/styles/global.js